import { map } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { RouterAction } from '@cbridge-packages/routing';
import { RulesManagementAction, ValidityFilterParam } from '@cbridge-modules/rules-management-page';

export const resetValidityFilterEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(RulesManagementAction.resetValidityFilter),
  map(() => RouterAction.removeParam(ValidityFilterParam.name)),
);
